import { PromotionContextProvider } from "src/contexts/promotion.context";
import { localeFix } from "src/utils/genderLocale/genderLocale";
import { PromoWrapper } from "../BrandView.styled";
import {
  PromotionDisplayType,
  PromotionType,
  ShopType,
} from "src/types/graphql.d";
import { PromoTimer } from "src/molecules/PromoTimer";
import { PromotionalBlock } from "src/molecules/PromotionalBlock";
import { Flex } from "@otrium/core";
import { usePromotion } from "src/hooks/usePromotion";

function Promotion({
  gender,
  slug,
}: {
  gender: string;
  slug: string;
}): JSX.Element | null {
  const { data: promotionData } = usePromotion(
    slug,
    PromotionType.Brand,
    localeFix({ gender }) as ShopType
  );

  if (!promotionData || !promotionData.promotion) {
    return null;
  }

  return (
    <PromoWrapper>
      <PromotionContextProvider>
        <PromoTimer
          promotion={promotionData.promotion}
          margins={{
            marginBlockStart: "space0",
            marginBlockEnd: "space0",
          }}
        />
        {promotionData.promotion.promo_display_type !==
          PromotionDisplayType.FlashSale &&
        (promotionData.promotion.promo_code ||
          promotionData.promotion.promo_message) ? (
          <Flex justifyContent="center">
            <PromotionalBlock promotion={promotionData.promotion || {}} />
          </Flex>
        ) : null}
      </PromotionContextProvider>
    </PromoWrapper>
  );
}

export { Promotion };
